import React from 'react'
import { TopBar } from 'prove-common'
import { AppLogo } from '../app-logo/AppLogo'

export const SelectThemeScreenTopBar: React.FC = () => {
  const breadcrumbItems = [
    {
      label: 'Innstillinger',
      to: '/settings'
    },
    {
      label: 'Velg tema'
    }
  ]
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={breadcrumbItems}
      showNotificationBell={true}
    />
  )
}
